var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 88,
    viewBox: "0 0 85 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1021 16.2683L20.3021 26.1349C16.2687 28.3683 12.9688 33.9683 12.9688 38.5683V57.4016C12.9688 62.0016 16.2687 67.6016 20.3021 69.8349L38.1021 79.7349C41.9021 81.8349 48.1354 81.8349 51.9354 79.7349L69.7354 69.8349C73.7687 67.6016 77.0687 62.0016 77.0687 57.4016V38.5683C77.0687 33.9683 73.7687 28.3683 69.7354 26.1349L51.9354 16.2349C48.1021 14.1349 41.9021 14.1349 38.1021 16.2683Z",
    fill: "white",
    stroke: "#0F0F0F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0687 38.5665L45.0029 57.4323L12.9688 38.5665C12.9688 36.4502 13.6672 34.1222 14.8143 32.0078L45.0029 49.8864L75.2232 32.0078C76.3703 34.1222 77.0687 36.4502 77.0687 38.5665Z",
    fill: "#BCEF3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9688 38.5665L45.0029 57.4323L77.0687 38.5665C77.0687 36.4502 76.3703 34.1222 75.2232 32.0078L45.0029 49.8864L14.8143 32.0078M12.9688 38.5665C12.9688 36.4502 13.6672 34.1222 14.8143 32.0078M12.9688 38.5665L14.8143 32.0078",
    stroke: "#0F0F0F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 32.8008L44.9958 49.8341L74.2292 32.9008",
    stroke: "#0F0F0F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 80.0341V49.8008",
    stroke: "#0F0F0F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3346 80.3932C77.6439 79.8601 78.7056 78.8414 79.2947 77.5618C79.8838 78.8414 80.9455 79.8601 82.2548 80.3932C80.9331 81.0264 79.8802 82.1184 79.2947 83.4596C78.7092 82.1184 77.6563 81.0264 76.3346 80.3932Z",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78588 17.5312C6.30058 16.6021 8.32759 14.6583 9.36755 12.1992C10.4075 14.6583 12.4345 16.6021 14.9492 17.5312C12.4083 18.6571 10.4008 20.7401 9.36755 23.3154C8.33432 20.7401 6.32685 18.6571 3.78588 17.5312Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3346 5.39321C19.6439 4.86011 20.7056 3.84136 21.2947 2.56185C21.8838 3.84136 22.9455 4.86012 24.2548 5.39321C22.9331 6.02642 21.8802 7.11842 21.2947 8.45956C20.7092 7.11842 19.6563 6.02641 18.3346 5.39321Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.77820435dc2cc92a7fbd779f5d4c017f.svg";
export { ForwardRef as ReactComponent };